module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aquila/aql_lines-4aefc7c3fc5f51dd502915dfc5a5617d.gif";